// Razorpay Checkout loader + opener. Loads the hosted checkout script on demand
// (once), then opens the modal for a server-created order. The success handler
// hands back the three fields the backend needs to verify the signature.

const SRC = "https://checkout.razorpay.com/v1/checkout.js";
let loader: Promise<void> | null = null;

export function loadRazorpay(): Promise<void> {
  if (typeof window !== "undefined" && (window as unknown as { Razorpay?: unknown }).Razorpay) return Promise.resolve();
  if (loader) return loader;
  loader = new Promise<void>((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SRC;
    s.onload = () => resolve();
    s.onerror = () => { loader = null; reject(new Error("Could not load the payment SDK")); };
    document.body.appendChild(s);
  });
  return loader;
}

export interface RazorpaySuccess {
  razorpay_order_id:   string;
  razorpay_payment_id: string;
  razorpay_signature:  string;
}

export interface CheckoutParams {
  keyId:    string;
  orderId:  string;
  amount:   number;
  currency: string;
  name:     string;
  description: string;
  prefill?: { email?: string; name?: string };
  onSuccess: (r: RazorpaySuccess) => void;
  onDismiss?: () => void;
}

export async function openRazorpayCheckout(p: CheckoutParams): Promise<void> {
  await loadRazorpay();
  const Rzp = (window as unknown as { Razorpay: new (o: unknown) => { open: () => void } }).Razorpay;
  const rzp = new Rzp({
    key:      p.keyId,
    order_id: p.orderId,
    amount:   p.amount,
    currency: p.currency,
    name:     p.name,
    description: p.description,
    ...(p.prefill ? { prefill: p.prefill } : {}),
    theme:   { color: "#3D9E8C" },
    handler: (res: RazorpaySuccess) => p.onSuccess(res),
    modal:   { ondismiss: () => p.onDismiss?.() },
  });
  rzp.open();
}
